import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';
class slideShow extends HTMLElement{
  constructor(){
    super();
    this.swiper = this.querySelector('.swiper') || this;
    // console.log(this.swiper);
  }
  connectedCallback(){
    this.init();
  }
  get AutoPlay(){
    return this.getAttribute('autoplay') || 3000;
  }
  config(){
    let attrs = {
      loop: this.getAttribute('loop') || true,
      pagination: {
        el: this.getAttribute('pagination' ) || '.swiper-pagination',
        clickable: true,
      }, 
      slidesPerView: 1
    }
    if (this.AutoPlay > 0){
      attrs.autoplay = {
        delay: this.AutoPlay,
        disableOnInteraction: false,
      }
    } 
    return attrs;
  }
  init(){
    this.swiper = new Swiper(this, this.config());
  }
  destroy(){
    this.swiper.destroy();
  }
}

customElements.define('lx-slideshow', slideShow);

console.log('luxuchi.js loaded');


class Slider extends HTMLElement{
  constructor(){
    super();
    this.swiper = this.querySelector('.swiper') || this;
    this.swiper2s = this.querySelectorAll('.swiper2');
  }
  get sectionId(){
    return this.getAttribute('section-id') || '';
  }
  get config(){
    const config = JSON.parse(document.getElementById(`${this.sectionId}-config`)?.textContent || '{}');
    // console.log(config, this.id);
    if (this.isFade){
      config.effect = 'fade';
    }
    return config || {};
  }
  get syncSlider(){
    return this.getAttribute('sync-slider') || '';
  }
  get isFade(){
    return this.getAttribute('is-fade') || false;
  }
  dispatchReady(){
    this.dispatchEvent(new CustomEvent('lx-slider:ready', {
      detail: { swiper: this.swiper },
      bubbles: true
    }));
  }
  linkControllers(targetSwiper){
    if (!targetSwiper || !this.swiper) return;
    this.swiper.controller.control = targetSwiper;
    if (targetSwiper.controller){
      targetSwiper.controller.control = this.swiper;
    }
  }
  syncWithTarget(){
    if (!this.syncSlider || !this.swiper) return;
    const target = document.getElementById(this.syncSlider);
    const targetSwiper = target?.swiperInstance;
    if (targetSwiper){
      this.linkControllers(targetSwiper);
    }
  }
  init(){
    // this.swiper = new Swiper(this.swiper, this.config || {});
    // if (this.syncSlider){
    //   this.swiper.controller.control = document.getElementById(this.syncSlider);
    // }
    // sau init
    if (this.isFade){
      this.defaultConfig.effect = 'fade';
    }
    if(this.swiper2s){
      this.swiper2s.forEach(swiper2 => {
        this.swiper2 = new Swiper(swiper2, {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: swiper2.querySelector('.swiper2-button-next'),
            prevEl: swiper2.querySelector('.swiper2-button-prev'),
          },
        });
      });
    }
    this.swiper = new Swiper(this.swiper, this.config || {});
    this.swiper.el.swiperInstance = this.swiper;
    this.swiperInstance = this.swiper;
    this.dispatchReady();
    this.syncWithTarget();
  }
  destroy(){
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy();
    }
  }

  reinit(){
    this.destroy();
    this.swiper = this.querySelector('.swiper') || this;
    this.init();
  }

  connectedCallback(){
    this.init();
    this.reinitHandler = this.reinit.bind(this);
    this.addEventListener('lx-slider:reinit', this.reinitHandler);
  }
  disconnectedCallback(){
    this.destroy();
    this.removeEventListener('lx-slider:reinit', this.reinitHandler);
  }
}

class SliderSync extends Slider{
  syncWithTarget(){
    if (!this.syncSlider || !this.swiper) return;
    const target = document.getElementById(this.syncSlider);
    if (!target) return;
    const targetSwiper = target.swiperInstance;
    if (targetSwiper){
      this.linkControllers(targetSwiper);
      return;
    }
    const onReady = (event)=>{
      const readySwiper = event.detail?.swiper;
      if (!readySwiper) return;
      this.linkControllers(readySwiper);
      target.removeEventListener('lx-slider:ready', onReady);
    };
    target.addEventListener('lx-slider:ready', onReady);
  }
}

customElements.define('lx-slider', Slider);
customElements.define('lx-slider-sync', SliderSync);


// Tabs

class Tabs extends HTMLElement{
  constructor(){
    super();
    this.tab_items = this.querySelectorAll('button[type="button"]');
    this.content_items = document.querySelectorAll(`#${this.tabContentId} .lx-tab-content-item`);
  }
  get _id(){
    return this.getAttribute('id') || '';
  }
  get tabContentId(){
    return this.getAttribute('aria-controls') || '';
  }
  get tabLineId(){
    return this.getAttribute('tab-line') || '';
  }

  init(){
    this.initLine();
  }
  initLine(){
    const tabLine = document.getElementById(this.tabLineId);
    tabLine.style.width = `${this.tab_items[0].offsetWidth}px`;
    tabLine.style.left = `${this.tab_items[0].offsetLeft}px`;
  }
  setupListeners(){

    this.tab_items.forEach(item => {
      item.addEventListener('click', this.handleClick.bind(this));
    });
  }
  handleClick(event){
    event.preventDefault();
    const target = event.currentTarget;
    const index = Array.from(this.tab_items).indexOf(target);
    this.setActiveTab(index,target);
  }
  setActiveTab(index,target){
    this.tab_items.forEach(item => {
      item.removeAttribute('is-active');
    });
    target.setAttribute('is-active', '');
    this.content_items.forEach(item => {
      item.removeAttribute('is-selected');
    });
    this.content_items[index].setAttribute('is-selected', '');
    this.updateTabLine(index);
  }
  updateTabLine(index){
    const tabLine = document.getElementById(this.tabLineId);
    tabLine.style.width = `${this.tab_items[index].offsetWidth}px`;
    tabLine.style.left = `${this.tab_items[index].offsetLeft}px`;
  }
  connectedCallback(){
    this.init();
    this.setupListeners();
  }
  disconnectedCallback(){
    this.destroy();
    this.removeEventListeners();
  }
  removeEventListeners(){
    this.tab_items.forEach(item => {
      item.removeEventListener('click', this.handleClick.bind(this));
    });
  }
}
customElements.define('lx-tab', Tabs);



// Accordion

class Accordion extends HTMLElement{
  constructor(){
    super();
    this.content = this.querySelector('[data-content]');
    this.section = this.closest(`#${this.sectionId}`) || document;
    this._link = this.querySelectorAll('a');
  }
  get sectionId(){
    return this.getAttribute('section-id') || '';
  }
  get isActive(){
    return this.hasAttribute('is-active');
  }
  get isFirst(){
    return this.hasAttribute('is-first');
  }
  get bannerId(){
    return this.getAttribute('aria-controls') || '';
  }
  get bannerEl(){
    return document.getElementById(this.bannerId);
  }
  get isMobile(){
    return this.hasAttribute('is-mobile');
  }
  connectedCallback(){
    this.handleResize = this.handleResize.bind(this);
    this.checkAndInit();
    window.addEventListener('resize', this.handleResize);
  }
  
  checkAndInit(){
    if(this.isMobile){
      if(window.innerWidth < 767){
        if(!this.isInitialized){
          this.init();
          this.setupListeners();
          this.isInitialized = true;
        }
      } else {
        this.cleanup();
      }
    }else{
      if(!this.isInitialized){
        this.init();
        this.setupListeners();
        this.isInitialized = true;
      }
    }
  }
  
  handleResize(){
    this.checkAndInit();
  }
  
  cleanup(){
    if(this.isInitialized){
      this.removeEventListener('click', this.handleClick);
      this.content.style.height = '';
      this.removeAttribute('is-active');
      this.removeAttribute('is-init');
      this.isInitialized = false;
    }
  }
  
  disconnectedCallback(){
    window.removeEventListener('resize', this.handleResize);
    this.cleanup();
  }
  setupListeners(){
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);
  }
  init(){
    if(this.isActive || this.isFirst){
      setTimeout(() => {
        this.content.style.height = this.content.scrollHeight + 'px';
        console.log(this.content.scrollHeight);
        this.setAttribute('is-active', '');
      }, 300);
    }else{
      this.content.style.height = '0';
    }
    this.setAttribute('is-init','');
  }
  handleClick(event){
    // event.preventDefault();
    if (this.content && this.content.contains(event.target)) return;
    let currentActive = this.section.querySelector('lx-accordion[is-active]');
    let currentBanner = this.section.querySelector('lx-banner-pin[is-active]');
    if (currentActive){
      currentActive.removeAttribute('is-active');
      currentActive.content.style.height = '0';
      currentBanner?.removeAttribute('is-active');
    }
    if(currentActive != this){
      this.setAttribute('is-active', '');
      this.content.style.height = this.content.scrollHeight + 'px';
    }
    if(this.bannerEl){
      this.bannerEl.setAttribute('is-active', '');
    }
    if(this.isActive){
      this.content.style.height = this.content.scrollHeight + 'px';
    }else{
      this.content.style.height = '0';
      this.removeAttribute('is-active');
    }
    this.dispatchEvent(new CustomEvent('lx-banner-pin:active', {
      detail: { bannerId: this.bannerId },
      bubbles: true
    }));
  }
}
customElements.define('lx-accordion', Accordion);

class itemMenuMobile extends HTMLElement{
  constructor(){
    super();
    this.click_icon = this.querySelector('[data-open-sub-menu]');
    this.close_sub_menu = this.querySelector('[close-sub-menu]'); 
  }
  connectedCallback(){
    this.init();
  }
  init(){
    if(this.click_icon){
      this.click_icon.addEventListener('click', this.handleClick.bind(this));
    }
    if(this.close_sub_menu){
      this.close_sub_menu.addEventListener('click', this.handleCloseSubMenu.bind(this));
    }
  }
  handleClick(event){
    event.preventDefault();
    this.setAttribute('is-active', '');
  }
  handleCloseSubMenu(event){
    event.preventDefault();
    this.removeAttribute('is-active');
  }
}
customElements.define('lx-menu-mobile-item', itemMenuMobile);

class ResultFilterCount extends HTMLElement{
  constructor(){
    super();
    this.count = this.querySelector('span');
  }
  connectedCallback(){
    this.init();
  }
  init(){
    document.addEventListener('facet:render', (e) => {
      // console.log("Facets rendered", e.detail);
    })
    // this.count.textContent = this.count.textContent.replace('(', '').replace(')', '');
  }
}
customElements.define('lx-result-filter-count', ResultFilterCount);

class MultiVariantOptions extends HTMLElement{
  constructor(){
    super();
    this.swatchs = this.querySelectorAll('lx-swatch-card');
    this.object_images = JSON.parse(this.querySelector('[data-color-media-json]')?.textContent || '{}');
  }
  connectedCallback(){
    // this.init();
    this.setupEvents();
  }
  init(){
    this.swatchs.forEach(swatch => {
      this.validateSwatch(swatch);
    });
  }
  setupEvents(){
    this.swatchs.forEach(swatch => {
      swatch.addEventListener('click', this.handleClick.bind(this));
    });
  }
  validateSwatch(swatch){
    let swatchImages = this.object_images[swatch.dataset.valueId];
    if(!swatchImages || swatchImages.length === 0){
      swatch.setAttribute('disabled', '');
      return;
    }
  }
  handleClick(event){
    event.preventDefault();
   
    const valueId = event.currentTarget.dataset.valueId; 
     this.closest('hdt-card-product').querySelector('lx-swatch-card[is-active]')?.removeAttribute('is-active');
     event.target.setAttribute('is-active', '');
     let images = this.object_images[valueId];
     this.closest('hdt-card-product')?.style.setProperty('opacity', '0.6');
     this.updateSlider(images, event.currentTarget);
  }
  updateSlider(images, target) {
    // 1. Tìm Product Card cha
    const productCard = target.closest('hdt-card-product') || target.closest('.hdt-card-product');
    if (!productCard) return;

    // 2. Tìm Slider Inner bên trong card đó
    const sliderInner = productCard.querySelector('lx-slider-inner');
    const swiperWrapper = sliderInner?.querySelector('.swiper-wrapper');

    if (swiperWrapper) {
      // 3. Tạo HTML mới cho các slide
      let newSlidesHtml = images.map(imgUrl => `
          <div class="swiper-slide">
              <img src="${imgUrl}" alt="" loading="lazy" width="600" height="600" class="hdt-w-full hdt-h-full hdt-object-contain">
          </div>
      `).join('');
      // 3.1 Append anh co san tu variant hien tai
      // const currentSwatch = target;
      // const currentSwatchImageUrl = currentSwatch.getAttribute('data-vimg').split('&width=')[0];
      // if(currentSwatchImageUrl){
      //   newSlidesHtml += `
      //     <div class="swiper-slide">
      //       <img src="${currentSwatchImageUrl}&width=600" alt="" loading="lazy" width="600" height="600" class="hdt-w-full hdt-h-full hdt-object-contain">
      //     </div>
      //   `;
      // }
      // 4. Update DOM
      swiperWrapper.innerHTML = newSlidesHtml;

      // 5. Gọi hàm reInit của sliderInner
      if (sliderInner && typeof sliderInner.reInit === 'function') {
        sliderInner.reInit();
        setTimeout(() => {
          this.closest('hdt-card-product')?.style.setProperty('opacity', '1');
        }, 300);
      }
    }
}
}
customElements.define('lx-variant-option', MultiVariantOptions);

class sliderInner extends HTMLElement{
  constructor(){
    super();
    // Đổi tên biến để tránh nhầm lẫn giữa Element và Instance
    this.swiperEl = this.querySelector('.swiper2') || this;
  }
  connectedCallback(){
    this.init();
  }
  init(){
    // Kiểm tra element tồn tại
    if (!this.swiperEl) return;
    
    // Kiểm tra xem đã có instance chưa để tránh init chồng
    if (this.swiperInstance) return;

    // Kiểm tra cấu trúc tối thiểu của Swiper
    const swiperWrapper = this.swiperEl.querySelector('.swiper-wrapper');
    if (!swiperWrapper) {
        console.warn('SliderInner: Missing .swiper-wrapper inside', this.swiperEl);
        return;
    }

    // Nếu chỉ có 1 slide hoặc ít hơn thì thêm class để CSS xử lý (ẩn nav)
    const slidesCount = swiperWrapper.querySelectorAll('.swiper-slide').length;
    if (slidesCount <= 1) {
        this.classList.add('is-single-slide');
    } else {
        this.classList.remove('is-single-slide');
    }

    this.swiperInstance = new Swiper(this.swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true, // Tự động disable nếu số slide <= slidesPerView
      allowTouchMove: false, // Không cho kéo nếu chỉ có 1 slide
      navigation: {
        nextEl: this.querySelector('.swiper2-button-next'),
        prevEl: this.querySelector('.swiper2-button-prev'),
      },
      observer: true, 
      observeParents: true,
    });
  }
  destroy(){
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
  reInit() {
    this.destroy();
    // Dùng requestAnimationFrame để đảm bảo DOM đã sẵn sàng
    requestAnimationFrame(() => {
        this.init();
    });
  }
  disconnectedCallback(){
    this.destroy();
  }
}
customElements.define('lx-slider-inner', sliderInner);


// Recommendations

class Recommendations extends HTMLElement{
  constructor(){
    super();
  }
  connectedCallback(){
    this.init();
  }
  init(){
    this.fetchAction();
  }
  fetchAction() {
    fetch(this.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('lx-recommendations');
      // console.log(recommendations);
      // return;

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
      }
      document.dispatchEvent(new CustomEvent("currency:update"));
      document.dispatchEvent(new CustomEvent('lx-slider:reinit'));
    })
    .catch((e) => {
      console.error(e);
    });
  }
}
customElements.define('lx-recommendations', Recommendations);


// Variant Compare

class VariantCompare extends HTMLElement{
  constructor(){
    super();
    this.variants = this.querySelectorAll('button[type="button"]');
    this.progressBar = this.querySelector('[data-progress-bar]');
    this.nextBtn = this.querySelector('[next-button]');
    this.prevBtn = this.querySelector('[previous-button]');
  }
  get buttonActiveIndex(){
    const activeButton = this.querySelector('button[type="button"][active]');
    return Array.from(this.variants).indexOf(activeButton);
  }
  get nextIndex(){
    const currentIndex = this.buttonActiveIndex;
    return currentIndex <= 0 ? this.variants.length - 1 : currentIndex - 1;
  }
  get prevIndex(){
    const currentIndex = this.buttonActiveIndex;
    return currentIndex >= this.variants.length - 1 ? 0 : currentIndex + 1;
  }
  connectedCallback(){
    // this.init();
    this.setupEvents();
    this.updateProgress();
  }
  setupEvents(){
    this.handleVarianClick();
    this.nextBtn.addEventListener('click', this.handleNextClick.bind(this));
    this.prevBtn.addEventListener('click', this.handlePrevClick.bind(this));
  }
  handleNextClick(){
    const nextVariant = this.variants[this.nextIndex];
    if (nextVariant) {
      nextVariant.click();
    }
  }
  handlePrevClick(){
    const prevVariant = this.variants[this.prevIndex];
    if (prevVariant) {
      prevVariant.click();
    }
  }
  handleVarianClick(){
    this.variants.forEach(btn => {
      btn.addEventListener('click', this.handleClick.bind(this));
    })
  }

  handleClick(event){
    event.preventDefault();
    const target = event.currentTarget.getAttribute('data-handle-arial');

    this.variants.forEach(btn => {
      btn.removeAttribute('active');
    });
    event.currentTarget.setAttribute('active', '');
    this.activeEl(target);
    this.updateProgress();
  }
  activeEl(target){
    this.querySelectorAll('[data-handle][active]').forEach(el => {
      el.removeAttribute('active');
    });

    this.querySelectorAll(`[data-handle="${target}"]`).forEach(el => {
      el.setAttribute('active', '');
    });
  }
  updateProgress(){
    const buttonActive = this.querySelector('button[type="button"][active]');
    if(buttonActive){
      const progress = (this.buttonActiveIndex + 1) / this.variants.length * 100;
      this.progressBar.style.setProperty('--width', `${progress}%`);
    }
  }

}
customElements.define('lx-variant-compare', VariantCompare);

// Mobile tooltip dialog system
(function() {
  function isMobile() {
    return window.innerWidth < 767 || 'ontouchstart' in window;
  }

  class MobileTooltipDialog {
    constructor() {
      this.activeDialog = null;
      this.createTooltipDialog();
    }

    createTooltipDialog() {
      // Tạo dialog element
      const dialog = document.createElement('dialog');
      dialog.id = 'mobile-tooltip-dialog';
      dialog.className = 'mobile-tooltip-dialog';
      
      // Style cho dialog
      dialog.style.cssText = `
        padding: 0;
        margin: 0;
        border: none;
        background: transparent;
        max-width: none;
        max-height: none;
        width: auto;
        height: auto;
        overflow: visible;
      `;
      
      // Template HTML
      dialog.innerHTML = `
        <div class="mobile-tooltip-content">
          <div class="mobile-tooltip-text"></div>
          <div class="mobile-tooltip-arrow"></div>
        </div>
      `;
      
      document.body.appendChild(dialog);
      this.dialog = dialog;
      
      // Close khi click outside
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
          this.hide();
        }
      });
    }

    show(triggerElement, message) {
      if (!this.dialog) return;
      
      // Update content
      const textElement = this.dialog.querySelector('.mobile-tooltip-text');
      textElement.textContent = message;
      
      // Show modal (vào top layer)
      this.dialog.showModal();
      
      // Position tooltip
      this.positionTooltip(triggerElement);
      
      this.activeDialog = this.dialog;
      
      // Auto hide sau 4 giây
      setTimeout(() => {
        this.hide();
      }, 10000);
    }

    positionTooltip(triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      const content = this.dialog.querySelector('.mobile-tooltip-content');
      
      // Position relative to viewport (vì dialog ở top layer)
      const left = rect.left + rect.width / 2;
      const top = rect.top - 10;
      
      content.style.cssText = `
        position: fixed;
        left: ${left}px;
        top: ${top}px;
        transform: translateX(-50%) translateY(-100%);
        z-index: 1;
      `;
    }

    hide() {
      if (this.activeDialog) {
        this.activeDialog.close();
        this.activeDialog = null;
      }
    }
  }

  // Global tooltip instance
  let tooltipDialog = null;

  function initTooltipDialog() {
    if (!tooltipDialog) {
      tooltipDialog = new MobileTooltipDialog();
    }
    return tooltipDialog;
  }

  function setupMobileTooltips() {
    if (!isMobile()) return;
    
    const tooltip = initTooltipDialog();
    
    document.querySelectorAll('.lx-filter-rule').forEach(element => {
      if (element.hasAttribute('data-mobile-dialog-setup')) return;
      element.setAttribute('data-mobile-dialog-setup', 'true');
      
      const messageElement = element.querySelector('.sr-only, [tt-title]');
      const message = messageElement ? messageElement.textContent.trim() : '';
      
      if (!message) return;
      
      // Touch events
      let touchStartTime = 0;
      let touchMoved = false;
      
      element.addEventListener('touchstart', function(e) {
        touchStartTime = Date.now();
        touchMoved = false;
      }, { passive: true });
      
      element.addEventListener('touchmove', function(e) {
        touchMoved = true;
      }, { passive: true });
      
      element.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const touchDuration = Date.now() - touchStartTime;
        
        // Tap nhanh
        if (!touchMoved && touchDuration < 500) {
          tooltip.show(element, message);
        }
      });
      
      // Fallback click
      element.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        tooltip.show(element, message);
      });
    });
  }

  // Setup
  document.addEventListener('DOMContentLoaded', setupMobileTooltips);
  document.addEventListener('products:update', () => {
    setTimeout(setupMobileTooltips, 100);
  });

})();